var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { Input, Th as XTh, ThDisabled as Disabled, ThSortable, SortWrapper as XSortWrapper, SortWrapperAsc, SortWrapperAscDisabled, SortWrapperDesc, SortWrapperDescDisabled, } from './Table.styled';
import { alignCenter, alignLeft, alignRight, divider as dividerCss, dividerBefore as dividerBeforeCss, inputDisabled, tdThCheckbox, } from '../styles/legacy';
import { tdThCheckbox as tdThCheckboxCitron } from '../styles/citron';
import { getAutomation, getDebug, getStyleNames } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { isNotNullOrEmpty } from '@pcty/utils';
var VERSION = '6.12.2';
var Th = function (_a) {
    var _b, _c;
    var _d = _a.align, align = _d === void 0 ? 'left' : _d, ariaLabel = _a["aria-label"], automationId = _a.automationId, _e = _a.checked, checked = _e === void 0 ? false : _e, children = _a.children, className = _a.className, 
    // NOTE: 'column' is not used in this file but it is used by parent components. DO NOT remove!
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    column = _a.column, css = _a.css, _f = _a.disabled, disabled = _f === void 0 ? false : _f, divider = _a.divider, dividerBefore = _a.dividerBefore, _g = _a.hidden, hidden = _g === void 0 ? false : _g, _h = _a.indeterminate, indeterminate = _h === void 0 ? false : _h, onChange = _a.onChange, onSort = _a.onSort, _j = _a.sort, sort = _j === void 0 ? [] : _j, _k = _a.sortArrow, sortArrow = _k === void 0 ? '' : _k, _l = _a.sortDirection, sortDirection = _l === void 0 ? 'default' : _l, _m = _a.__TYPE, TYPE = _m === void 0 ? 'Th' : _m, other = __rest(_a, ["align", 'aria-label', "automationId", "checked", "children", "className", "column", "css", "disabled", "divider", "dividerBefore", "hidden", "indeterminate", "onChange", "onSort", "sort", "sortArrow", "sortDirection", "__TYPE"]);
    if (hidden)
        return React.createElement(React.Fragment, null);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var isCitron = useTheme().citrus2022;
    var emotionObj = (_b = {},
        _b[emotionCss(alignCenter)] = align === 'center',
        _b[emotionCss(alignLeft)] = align === 'left',
        _b[emotionCss(alignRight)] = align === 'right',
        _b[emotionCss(isCitron ? tdThCheckboxCitron : tdThCheckbox)] = TYPE === 'ThCheckbox',
        _b[emotionCss(dividerCss)] = divider !== null && divider !== void 0 ? divider : false,
        _b[emotionCss(dividerBeforeCss)] = dividerBefore !== null && dividerBefore !== void 0 ? dividerBefore : false,
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b);
    var classes = cx(emotionObj, className || '');
    var styleNames = {
        alignCenter: emotionObj[emotionCss(alignCenter)],
        alignLeft: emotionObj[emotionCss(alignLeft)],
        alignRight: emotionObj[emotionCss(alignRight)],
        tdThCheckbox: emotionObj[emotionCss(isCitron ? tdThCheckboxCitron : tdThCheckbox)],
        dividerCss: emotionObj[emotionCss(dividerCss)],
        dividerBeforeCss: emotionObj[emotionCss(dividerBeforeCss)],
    };
    var inputCss = cx((_c = {},
        _c[emotionCss(inputDisabled)] = disabled,
        _c));
    var Component = getComponent(onSort, disabled);
    var SortWrapper = getSortWrapper(sortArrow, disabled);
    var onClick = disabled ? function () { return undefined; } : function () { return handleSort(sortDirection, sort, onSort); };
    var checkbox = TYPE === 'ThCheckbox' ? (React.createElement(Input, { "aria-label": ariaLabel, checked: checked, className: inputCss, disabled: disabled, onChange: onChange, ref: function (input) {
            if (input) {
                input.indeterminate = indeterminate;
            }
        }, type: "checkbox" })) : undefined;
    var sortJsx = isNotNullOrEmpty(children) ? React.createElement(SortWrapper, null, children) : undefined;
    return (React.createElement(Component, __assign({ className: classes, onClick: function (e) { return (e.target.type === 'checkbox' ? undefined : onClick()); }, styleNames: getStyleNames(styleNames) }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)),
        checkbox,
        sortJsx));
};
var getComponent = function (onSort, disabled) {
    if (disabled) {
        return Disabled;
    }
    return onSort ? ThSortable : XTh;
};
var getSortWrapper = function (direction, disabled) {
    switch (direction) {
        case 'asc':
            return disabled ? SortWrapperAscDisabled : SortWrapperAsc;
        case 'desc':
            return disabled ? SortWrapperDescDisabled : SortWrapperDesc;
        default:
            return XSortWrapper;
    }
};
var handleSort = function (direction, sort, onSort) {
    if (!onSort)
        return;
    switch (direction) {
        case '':
        case 'reverse':
        default:
            direction = 'default';
            break;
        case 'default':
            direction = 'reverse';
            break;
    }
    onSort(direction, sort);
};
Th.defaultProps = {
    __TYPE: 'Th',
};
export default Th;
